import _ from 'lodash';
import TemplateCardAdaptive from '../../TemplateCard/TemplateCardAdaptive';

interface Props {
  isMobileView?: boolean;
}

const TemplateCardListItemsLoadingState = ({ isMobileView = false }: Props) => {
  return (
    <>
      {_.map(_.range(0, 4), (index) => (
        <li key={index}>
          <TemplateCardAdaptive
            isMobileView={isMobileView}
            template={{ purchaseCount: 0 }}
            forceRender={false}
            loader={true}
            index={index}
          />
        </li>
      ))}
    </>
  );
};

export default TemplateCardListItemsLoadingState;
